
import React from 'react';
import { Label } from '@core-ui/Components/ui/label.tsx';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  oldVersion: string;
  newVersion: string;
}

export const VersionCheckBanner: React.FC<Props> = ({ oldVersion, newVersion }) => {
  const { t } = useTranslation();

  return (
    <Label
      className="flex justify-center h-7.5 w-auto gap-2 bg-amber-500/10
               text-amber-700 dark:text-amber-300 border border-amber-500/30
               whitespace-nowrap px-2 py-1"
    >
      <>
        <AlertTriangle className="h-4 w-4 text-amber-700 dark:text-amber-300"/>
        <span className="text-amber-700 dark:text-amber-300">{t('versionCheckBanner.message', { oldVersion, newVersion })}</span>
        <a 
          onClick={() => {
            window.location.href = window.location.pathname + '?v=' + newVersion;
          }}
          className="hover:cursor-pointer hover:text-amber-500/90 underline"
        >{t('versionCheckBanner.update')}</a>
      </>
    </Label>
  );
};

export default VersionCheckBanner;